import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item";

export const MarketplaceNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });
  return (
    <NavItem
      icon="marketplace"
      {...props}
      isActiveTest={(path) => path.match(/^\/marketplace/)}
      name={t("marketplace")}
      id="marketplace"
      href="/marketplace"
    />
  );
};
